import {
  CAMPAIGN_CONFIGURATION_SUBMITTED,
  CAMPAIGN_REWARDS_GENERATED,
  CAMPAIGN_CREATE_STARTED,
  CAMPAIGN_CREATE_SUBMITTED,
  CAMPAIGN_RESET,
} from '../actionTypes';

export const getDefaultState = () => ({
  id: '',
  name: '',
  tokenAddress: '',
  tokensPerCode: null,
  numberOfCodes: 0,
  totalTokens: null,
  rewards: [],
  transactionHash: '',
});

const reducer = (state = getDefaultState(), action) => {
  switch (action.type) {
    case CAMPAIGN_CONFIGURATION_SUBMITTED:
      return {
        ...state,
        name: action.name,
        tokenAddress: action.tokenAddress,
        tokensPerCode: action.tokensPerCode,
        numberOfCodes: action.numberOfCodes,
        totalTokens: action.totalTokens,
        transactionHash: '',
      };

    case CAMPAIGN_RESET: {
      return getDefaultState();
    }

    case CAMPAIGN_REWARDS_GENERATED:
      return { ...state, rewards: action.rewards };

    case CAMPAIGN_CREATE_STARTED:
      return {
        ...state,
        id: action.campaign.id,
      };

    case CAMPAIGN_CREATE_SUBMITTED:
      return {
        ...state,
        transactionHash: action.transactionHash,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/createCampaign.js